/**
 * Step 1: Cidade e Estado
 * Coleta informações sobre localização
 */

import React, { useState } from 'react';
import { StepContainer, FormFieldGroup, StepNavigation } from '../components';
import { StepProps, useFormContext } from '../context';
import { useFormValidation } from '../hooks';
import { validateText } from '../validators';

const Step1_Cidade: React.FC<StepProps> = ({ onNext, onPrevious, data, isLoading }) => {
  const { updateFields } = useFormContext();
  const [localData, setLocalData] = useState({ cityState: data.cityState || '' });
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleChange = (value: string) => {
    setLocalData({ cityState: value });
    setErrors({});
  };

  const handleNext = () => {
    const validation = validateText(localData.cityState, 2);
    
    if (!validation.valid) {
      setErrors({ cityState: validation.error || 'Campo obrigatório' });
      return;
    }

    updateFields(localData);
    onNext(localData);
  };

  return (
    <StepContainer
      title="Qual seu estado e cidade?"
      description="Precisamos saber sua localização"
    >
      <FormFieldGroup
        label="Estado e Cidade"
        error={errors.cityState}
        required
      >
        <input
          type="text"
          placeholder="Cascavel PR"
          value={localData.cityState}
          onChange={(e) => handleChange(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-[#5c5c5c]"
        />
      </FormFieldGroup>

      <StepNavigation
        onNext={handleNext}
        onPrevious={onPrevious}
        isLoading={isLoading}
        showPrevious={true}
      />
      <hr className="my-2" />
      <p className="text-xs text-muted-foreground">
        ⚠️ Importante: preencha todos os itens com atenção, pois esses dados vão direto para criar o seu cadastro no app Xizinha. Depois de finalizado, não tem como corrigir informações!
      </p>
    </StepContainer>
  );
};

export default Step1_Cidade;
